import { useId } from 'react';

export const OrbIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  const id = useId();
  const a = `${id}-a`;
  const b = `${id}-b`;
  const c = `${id}-c`;
  const d = `${id}-d`;
  const e = `${id}-e`;
  const f = `${id}-f`;
  const g = `${id}-g`;
  const h = `${id}-h`;
  const i = `${id}-i`;
  const j = `${id}-j`;
  const k = `${id}-k`;
  const l = `${id}-l`;
  const m = `${id}-m`;
  const n = `${id}-n`;
  const o = `${id}-o`;
  const p = `${id}-p`;
  const q = `${id}-q`;
  const r = `${id}-r`;
  const s = `${id}-s`;
  const t = `${id}-t`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" {...props}>
      <g opacity=".5">
        <g filter={`url(#${a})`}>
          <path
            fill="#272727"
            d="M18.45 10.595c0 4.582-2.88 7.852-7.548 7.852s-8.453-3.714-8.453-8.296 3.785-7.704 8.453-7.704 7.547 3.566 7.547 8.148"
          />
          <mask id={b} width="17" height="17" x="2" y="2" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
            <path
              fill="#182333"
              d="M18.45 10.595c0 4.582-2.88 7.852-7.548 7.852s-8.453-3.714-8.453-8.296 3.785-7.704 8.453-7.704 7.547 3.566 7.547 8.148"
            />
          </mask>
          <g mask={`url(#${b})`}>
            <mask id={d} width="17" height="17" x="2" y="2" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
              <path
                fill={`url(#${c})`}
                d="M18.45 10.595c0 4.582-2.88 7.852-7.548 7.852s-8.453-3.714-8.453-8.296 3.785-7.704 8.453-7.704 7.547 3.566 7.547 8.148"
              />
            </mask>
            <g mask={`url(#${d})`}>
              <g filter={`url(#${e})`}>
                <path
                  fill="#818181"
                  fillRule="evenodd"
                  d="M-.342-4.007c1.733.43 2.517 2.357 3.608 3.765.767.99 1.123 2.136 1.786 3.197.971 1.556 3.73 2.778 2.993 4.456-.772 1.757-3.874.214-5.498 1.245-1.445.916-1.176 4.08-2.889 4.078-1.714-.001-1.584-2.972-2.884-4.083-1.118-.955-3.035-.587-3.937-1.746C-8.198 5.577-8.6 3.778-8.312 2.122-8 .332-6.984-1.31-5.54-2.42c1.47-1.13 3.395-2.032 5.198-1.586"
                  clipRule="evenodd"
                />
              </g>
              <g filter={`url(#${f})`}>
                <path
                  fill="#fff"
                  fillRule="evenodd"
                  d="M10.514-5.723c1.733.429 2.517 2.356 3.607 3.764.767.99 1.123 2.136 1.786 3.197.972 1.556 3.731 2.778 2.994 4.457-.772 1.757-3.874.213-5.499 1.244-1.444.917-1.175 4.08-2.888 4.078-1.714-.001-1.585-2.972-2.885-4.083-1.117-.955-3.035-.587-3.937-1.746C2.658 3.86 2.256 2.061 2.544.405c.311-1.79 1.327-3.433 2.771-4.543 1.47-1.13 3.396-2.031 5.199-1.585"
                  clipRule="evenodd"
                />
              </g>
              <g filter={`url(#${g})`}>
                <path
                  fill="#acacac"
                  fillRule="evenodd"
                  d="M22.56 24.46c-1.658.662-3.419-.446-5.126-.954-1.2-.357-2.158-1.08-3.315-1.555-1.697-.698-4.651-.081-5.031-1.875-.397-1.877 3.023-2.432 3.741-4.217.639-1.587-1.425-4-.032-4.998s3.02 1.49 4.724 1.635c1.465.124 2.808-1.293 4.217-.878 1.614.475 2.99 1.702 3.722 3.215.79 1.636.924 3.563.398 5.307-.535 1.776-1.573 3.63-3.298 4.32"
                  clipRule="evenodd"
                />
              </g>
              <g filter={`url(#${h})`}>
                <path
                  fill="#b6b6b6"
                  fillRule="evenodd"
                  d="M13.274 14.018c-.763.304-1.574-.206-2.36-.44-.553-.164-.994-.497-1.527-.716-.78-.321-2.141-.037-2.316-.863-.183-.864 1.392-1.12 1.723-1.942.294-.73-.656-1.841-.015-2.3.641-.46 1.39.685 2.175.752.675.057 1.293-.596 1.941-.405.744.22 1.378.784 1.714 1.481.364.753.426 1.64.184 2.444-.246.817-.725 1.671-1.519 1.989"
                  clipRule="evenodd"
                />
              </g>
              <g filter={`url(#${i})`}>
                <path
                  fill="#5c5c5c"
                  fillRule="evenodd"
                  d="M-.543 14.65c.66-.583 2.335-.245 3.653-.218.927.02 1.902.267 2.867.356 1.414.13 2.893-.611 4.089.282 1.252.935-.545 1.709-.026 2.752.461.927 3.022 1.91 2.705 2.633-.318.722-2.652-.363-3.773-.2-.964.14-1.026 1.078-2.112 1.056-1.244-.024-2.746-.478-4.007-1.174-1.363-.752-2.48-1.75-3.096-2.745-.626-1.012-.986-2.137-.3-2.743"
                  clipRule="evenodd"
                />
              </g>
              <g filter={`url(#${j})`}>
                <path
                  fill="#585858"
                  fillRule="evenodd"
                  d="M-.543 14.65c.66-.583 2.335-.245 3.653-.218.927.02 1.902.267 2.867.356 1.414.13 2.893-.611 4.089.282 1.252.935-.545 1.709-.026 2.752.461.927 3.022 1.91 2.705 2.633-.318.722-2.652-.363-3.773-.2-.964.14-1.026 1.078-2.112 1.056-1.244-.024-2.746-.478-4.007-1.174-1.363-.752-2.48-1.75-3.096-2.745-.626-1.012-.986-2.137-.3-2.743"
                  clipRule="evenodd"
                />
              </g>
              <g filter={`url(#${k})`}>
                <path
                  fill="#777"
                  fillRule="evenodd"
                  d="M6.665 8.904c.446-.394 1.578-.166 2.47-.147.627.013 1.286.18 1.938.24.956.088 1.956-.413 2.765.191.847.632-.368 1.155-.018 1.86.312.628 2.043 1.293 1.83 1.78-.215.49-1.794-.244-2.552-.134-.652.095-.693.728-1.427.714-.842-.016-1.858-.323-2.71-.794-.922-.508-1.677-1.183-2.093-1.856-.424-.684-.667-1.445-.203-1.854"
                  clipRule="evenodd"
                />
              </g>
              <g filter={`url(#${l})`} style={{ mixBlendMode: 'overlay' }}>
                <path
                  fill="#c7c7c7"
                  fillRule="evenodd"
                  d="M4.708 13.16c-.764.305-1.574-.206-2.36-.44-.553-.163-.994-.496-1.527-.715-.781-.321-2.142-.038-2.316-.863-.183-.865 1.391-1.12 1.722-1.942.294-.731-.656-1.842-.015-2.301.642-.46 1.391.686 2.176.752.674.057 1.293-.595 1.941-.404.744.219 1.377.784 1.714 1.48.364.754.425 1.641.183 2.444-.246.818-.724 1.672-1.518 1.989"
                  clipRule="evenodd"
                />
              </g>
              <g filter={`url(#${m})`} style={{ mixBlendMode: 'overlay' }}>
                <path
                  fill="#afafaf"
                  fillRule="evenodd"
                  d="M18.017 11.006c-.847.238-2.209-.793-3.384-1.39-.827-.421-1.598-1.067-2.429-1.566-1.217-.73-2.87-.706-3.56-2.03-.722-1.385 1.232-1.302 1.218-2.467C9.849 2.518 7.97.52 8.569.007c.6-.513 2.23 1.478 3.312 1.818.93.292 1.391-.525 2.36-.035 1.111.562 2.267 1.624 3.1 2.798.902 1.27 1.475 2.654 1.597 3.817.125 1.184-.04 2.353-.92 2.601"
                  clipRule="evenodd"
                />
              </g>
            </g>
            <g filter={`url(#${n})`} style={{ mixBlendMode: 'overlay' }}>
              <path
                stroke="#fff"
                strokeWidth=".918"
                d="M17.592 10.304c0 4.419-2.724 7.572-7.143 7.572a8 8 0 0 1-8-8c0-4.418 3.582-7.429 8-7.429s7.143 3.44 7.143 7.857Z"
              />
            </g>
            <g filter={`url(#${o})`} style={{ mixBlendMode: 'overlay' }}>
              <path
                stroke="#fff"
                strokeWidth=".612"
                d="M17.592 10.304c0 4.419-2.724 7.572-7.143 7.572a8 8 0 0 1-8-8c0-4.418 3.582-7.429 8-7.429s7.143 3.44 7.143 7.857Z"
              />
            </g>
          </g>
        </g>
        <mask id={p} width="17" height="17" x="2" y="3" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
          <path
            fill="#182333"
            d="M18.45 11.761c0 4.582-2.88 7.852-7.548 7.852S2.449 15.9 2.449 11.317s3.785-7.704 8.453-7.704 7.547 3.567 7.547 8.148"
          />
        </mask>
        <g mask={`url(#${p})`}>
          <g filter={`url(#${q})`} style={{ mixBlendMode: 'overlay' }}>
            <path
              fill="#959595"
              fillRule="evenodd"
              d="M5.134 16.306c-1.08.44-2.21-.255-3.31-.565-.773-.218-1.386-.673-2.131-.968-1.092-.431-3.01-.01-3.239-1.156-.24-1.2 1.978-1.587 2.46-2.738.427-1.023-.887-2.551.023-3.203.911-.653 1.942.928 3.044 1.005.946.066 1.828-.854 2.736-.601 1.041.29 1.92 1.065 2.38 2.028.497 1.041.566 2.276.21 3.399-.362 1.143-1.05 2.342-2.173 2.799"
              clipRule="evenodd"
            />
          </g>
          <g filter={`url(#${r})`} style={{ mixBlendMode: 'overlay' }}>
            <path
              fill="#6b6b6b"
              fillRule="evenodd"
              d="M11.465 7.755c-1.373.733-2.477.39-3.659.408-.83.013-1.408-.248-2.184-.317-1.136-.1-3.473.856-3.408-.18.067-1.084 2.74-2.093 3.627-3.337.788-1.106-.29-2.197.949-3.086 1.24-.888 1.975.334 3.225.092C11.09 1.126 12.374-.012 13.35-.03c1.118-.02 1.911.472 2.165 1.265.275.858 0 2.024-.734 3.206-.747 1.202-1.887 2.552-3.315 3.314"
              clipRule="evenodd"
            />
          </g>
          <g filter={`url(#${s})`} style={{ mixBlendMode: 'overlay' }}>
            <path
              fill="#d5d5d5"
              fillRule="evenodd"
              d="M11.859 12.201c-.437-2.4.167-3.703.418-5.356.177-1.163.576-1.788.824-2.819.363-1.51-.083-5.4.963-4.611 1.095.826 1.518 5.22 2.59 7.291.953 1.842 2.316 1.082 2.943 3.402.627 2.322-.794 2.518-.83 4.418-.033 1.632.84 4.183.635 5.55-.235 1.567-.92 2.336-1.79 2.153-.942-.198-2.074-1.368-3.116-3.185-1.061-1.85-2.183-4.345-2.637-6.843"
              clipRule="evenodd"
            />
          </g>
        </g>
        <g filter={`url(#${t})`} style={{ mixBlendMode: 'plus-lighter' }}>
          <path
            fill="#4d4d4d"
            fillRule="evenodd"
            d="M14.87 12.393c-.62.783-1.503.809-2.29 1.086-.553.195-1.048.156-1.598.285-.805.19-1.98 1.335-2.364.65-.402-.719.977-1.974 1.059-2.98.072-.893-1.103-1.358-.637-2.213.465-.854 1.465-.227 2.205-.665.635-.376 1.027-1.402 1.676-1.633.743-.264 1.479-.124 1.977.334.539.494.835 1.312.83 2.243-.005.947-.213 2.078-.858 2.893"
            clipRule="evenodd"
          />
        </g>
      </g>
      <defs>
        <filter
          id={a}
          width="20.896"
          height="20.896"
          x=".001"
          y="-.001"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="1.224" />
        </filter>
        <filter
          id={e}
          width="31.258"
          height="31.545"
          x="-15.746"
          y="-11.467"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.672" />
        </filter>
        <filter
          id={f}
          width="31.258"
          height="31.545"
          x="-4.891"
          y="-13.184"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.672" />
        </filter>
        <filter
          id={g}
          width="31.805"
          height="28.729"
          x="1.711"
          y="3.281"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.672" />
        </filter>
        <filter
          id={h}
          width="22.571"
          height="21.151"
          x="-.289"
          y=".304"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.672" />
        </filter>
        <filter
          id={i}
          width="25.927"
          height="19.242"
          x="-7.034"
          y="8.191"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <filter
          id={j}
          width="25.927"
          height="19.242"
          x="-7.034"
          y="8.191"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <filter
          id={k}
          width="21.494"
          height="16.974"
          x=".294"
          y="2.554"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <filter
          id={l}
          width="20.123"
          height="18.703"
          x="-7.632"
          y=".671"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <filter
          id={m}
          width="22.767"
          height="23.357"
          x="2.329"
          y="-6.196"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <filter
          id={n}
          width="21.57"
          height="21.854"
          x="-.766"
          y="-.766"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="1.377" />
        </filter>
        <filter
          id={o}
          width="20.038"
          height="20.325"
          x=".003"
          y="-.001"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="1.071" />
        </filter>
        <filter
          id={q}
          width="23.334"
          height="21.17"
          x="-9.682"
          y="1.398"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <filter
          id={r}
          width="25.646"
          height="20.498"
          x="-3.909"
          y="-6.149"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <filter
          id={s}
          width="20.295"
          height="35.185"
          x="5.583"
          y="-6.809"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <filter
          id={t}
          width="19.427"
          height="20.078"
          x="2.423"
          y=".671"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_7199_120644" stdDeviation="3.06" />
        </filter>
        <linearGradient id={c} x1="10.902" x2="10.902" y1="1.855" y2="18.447" gradientUnits="userSpaceOnUse">
          <stop stopColor="#c4c4c4" />
          <stop offset="1" stopColor="#434343" />
        </linearGradient>
      </defs>
    </svg>
  );
};
